<template>
  <div class="mypage">
    <AnnounceComponent class="mb-3"/>
    <div class="d-flex flex-wrap">
      <div class="w-25 mb-3">
        <router-link
          :to="{name: 'Students'}"
          class="common__dashboard_link"
        >
          StudentList
        </router-link>
      </div>
    </div>
    <div class="d-flex flex-wrap">
      <div class="w-25 mb-3">
        <a
          class="common__dashboard_link"
          href="https://led.w-as.jp/guide.html"
          rel="noreferrer"
          target="_blank"
        >
          <img src="@/assets/CourseGuide.png">
        </a>
      </div>
      <div class="w-25 mb-3">
        <a
          class="common__dashboard_link"
          href="https://led.w-as.jp/data/te/2021-te-lesson-calender.pdf"
          rel="noreferrer"
          target="_blank"
        >
          <img src="@/assets/AnnualSchedule.png">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import AnnounceComponent from '@/components/parts/mypage/AnnounceComponent.vue';

export default {
  components: {
    AnnounceComponent,
  },
};
</script>
